import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import store from './ReduxStore/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './Container/App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
   <Provider store={store}>
  {/* <BrowserRouter> */}
  <BrowserRouter basename={'/'}>
    <App />
  </BrowserRouter>
  </Provider> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

